import clsx from "clsx";

import type { JobStatus } from "@/lib/types";

const styles: Record<JobStatus, { bg: string; text: string; glow: string; icon: string }> = {
  pending: {
    bg: "bg-cyber-cyan/10",
    text: "text-cyber-cyan",
    glow: "glow-cyan animate-neon-pulse",
    icon: "○",
  },
  processing: {
    bg: "bg-cyber-magenta/10",
    text: "text-cyber-magenta",
    glow: "glow-magenta",
    icon: "◐",
  },
  awaiting_response: {
    bg: "bg-cyber-magenta/10",
    text: "text-cyber-magenta",
    glow: "glow-magenta",
    icon: "◌",
  },
  completed: {
    bg: "bg-cyber-green/10",
    text: "text-cyber-green",
    glow: "glow-green",
    icon: "✓",
  },
  cancelled: {
    bg: "bg-cyber-muted/10",
    text: "text-cyber-muted",
    glow: "",
    icon: "-",
  },
  failed: {
    bg: "bg-cyber-red/10",
    text: "text-cyber-red",
    glow: "glow-red",
    icon: "✗",
  },
};

interface StatusBadgeProps {
  status: JobStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const style = styles[status];

  return (
    <span
      className={clsx(
        "inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-medium uppercase tracking-wider",
        style.bg,
        style.text,
        style.glow,
      )}
    >
      <span
        className={
          status === "processing" || status === "awaiting_response"
            ? "animate-spin-glow inline-block"
            : ""
        }
      >
        {style.icon}
      </span>
      {status}
    </span>
  );
}
